import React, {useEffect} from "react";
import {Controller, useForm} from "react-hook-form";
import {Select, Spin} from "antd";
import {LoadingOutlined} from "@ant-design/icons";

export const FormQuery: React.FC<{ isRequesting: boolean, onChange: () => void, onQuery: (formData: any) => void }>
    = ({
           isRequesting,
           onChange,
           onQuery
       }) => {
    const {
        handleSubmit,
        setValue,
        formState: {errors},
        control,
        watch
    } = useForm()

    const formValues = watch()

    useEffect(() => {
        setValue("round", undefined);
        onChange();
    }, [formValues.block])
    useEffect(() => {
        setValue("round_1", undefined);
        onChange();
    }, [formValues.round])
    useEffect(() => {
        onChange();
    }, [formValues.round_1])

    return <div className={"w-[1200px] overflow-x-auto mt-4"}>
        <form action="#" onSubmit={handleSubmit(onQuery)}>
            <ul className={"flex gap-4 text-[#252525] items-end"}>
                <li className={"flex-1 flex flex-col text-sm"}>
                    <label>Chọn khối lớp</label>
                    <Controller
                        name={"block"}
                        control={control}
                        rules={{required: "Vui lòng chọn khối lớp"}}
                        render={({field}) =>
                            <Select className={`h-[50px] mt-1`}
                                    {...field}
                                    status={errors?.block?.message ? "error" : undefined}
                                    placeholder={"Chọn khối"}>
                                {[3, 4].map((item, index) =>
                                    <Select.Option key={index} value={item}>
                                        Khối {item}
                                    </Select.Option>)}
                            </Select>}/>
                </li>
                <li className={"flex-1 flex flex-col text-sm"}>
                    <label>Chọn round thi</label>
                    <Controller
                        name={"round"}
                        control={control}
                        rules={{required: "Vui lòng chọn round thi"}}
                        render={({field}) =>
                            <Select className={`h-[50px] mt-1`}
                                    {...field}
                                    disabled={formValues?.block === undefined}
                                    status={errors?.round?.message ? "error" : undefined}
                                    placeholder={"Chọn round"}>
                                {[1, 2, 3].map((item, index) =>
                                    <Select.Option key={index} value={item}>
                                        Round {item}
                                    </Select.Option>)}
                            </Select>}/>
                </li>
                {![2, 3].includes(formValues?.round) && <li className={"flex-1 flex flex-col text-sm"}>
                    <label>Chọn vòng thi</label>
                    <Controller
                        name={"round_1"}
                        control={control}
                        rules={{required: "Vui lòng chọn vòng thi"}}
                        render={({field}) =>
                            <Select className={`h-[50px] mt-1`}
                                    {...field}
                                    disabled={formValues?.round === undefined}
                                    status={errors?.round_1?.message ? "error" : undefined}
                                    placeholder={"Chọn vòng"}>
                                {[0, 1, 2, 3, 4, 5].map((item, index) =>
                                    <Select.Option key={index}
                                                   value={item}>
                                        {item === 0 ? "Tổng kết round 1" : `Vòng ${item}`}
                                    </Select.Option>)}
                            </Select>}/>
                </li>}
                <li className={"flex-1 text-sm"}>
                    <button className={"relative text-base bg-[#0095DA] w-full h-[50px] rounded-lg text-white font-bold"}
                            disabled={isRequesting}>
                        {isRequesting &&
                            <Spin className={"absolute left-4"} indicator={<LoadingOutlined style={{fontSize: 24, color: 'white'}} spin/>}/>}
                        Xem kết quả
                    </button>
                </li>
            </ul>
        </form>
    </div>
}
